import { AbilityBuilder, createMongoAbility } from "@casl/ability";
import { defineAdminRules } from "./rules/admin";
import { defineAuthenticatedRules } from "./rules/authenticated";
import { defineOrganizationRules } from "./rules/organization";
import { definePartnerRules } from "./rules/partner";
import { definePublicRules } from "./rules/public";
import type { AppAbility, DefineAbilityForUser } from "./types";

export function defineAbilityFor(
  user: DefineAbilityForUser | null,
): AppAbility {
  const { can, cannot, build } = new AbilityBuilder<AppAbility>(
    createMongoAbility,
  );

  definePublicRules(can);

  if (user) {
    defineAuthenticatedRules({ can, cannot });

    if (user.role === "admin") {
      defineAdminRules({ can, user });
    } else if (user.role === "partner") {
      definePartnerRules({ can, user });
    }

    if (user.organizationId && user.type === "organization") {
      defineOrganizationRules({ can, cannot, user });
    }
  }

  return build({
    detectSubjectType: (item) => {
      if (item && typeof item === "object" && item[Symbol.for("subjectType")]) {
        return item[Symbol.for("subjectType")];
      }
      return item?.constructor?.name; // fallback para classes
    },
  });
}
